import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS } from '@modules/affiliate-program-commissions/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IAffiliateProgramCommissionItem,
  IAffiliateProgramCommissionItemResponse,
} from '../types';
import {
  AFFILIATE_PROGRAM_COMMISSIONS_ITEM_QUERY_KEY,
  AFFILIATE_PROGRAM_COMMISSIONS_ITEM_URL,
} from '../constants';

export default function useAffiliateProgramCommissionsItemQuery(
  id: Ref<number | undefined>,
): IContextQueryResult<IAffiliateProgramCommissionItemResponse, Error, IAffiliateProgramCommissionItem> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateProgramCommissionItemResponse, Error, IAffiliateProgramCommissionItem>({
    queryKey: [AFFILIATE_PROGRAM_COMMISSIONS_ITEM_QUERY_KEY, id],
    queryFn: ({ signal }) => fetchGet<IAffiliateProgramCommissionItemResponse>(
      AFFILIATE_PROGRAM_COMMISSIONS_ITEM_URL,
      {
        urlParams: {
          id: id.value,
        },
        signal,
        permission: AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS.EDIT,
      },
    ),
    select: (data) => data.condition,
    enabled: computed(() => !!id.value),
  });
}
